module.exports = __webpack_public_path__ + "static/media/img_drawing4.8a9583d1.png";